import { CardHistoricoConfig } from "./Base/types";
import { servicoCriadoConfig } from "./Cards/ServicoCriado/CardServicoCriado";
import { servicoEditadoConfig } from "./Cards/ServicoEditado/CardServicoEditado";
import { planoCriadoConfig } from "./Cards/PlanoCriado/CardPlanoCriado";
import { planoEditadoConfig } from "./Cards/PlanoEditado/CardPlanoEditado";
import { servicoAdicionadoConfig } from "./Cards/ServicoAdicionado/CardServicoAdicionado";
import { precificacaoEditadaConfig } from "./Cards/PrecificacaoEditada/CardPrecificacaoEditada";
import { novoPrecoAdicionadoConfig } from "./Cards/NovoPrecoAdicionado/CardNovoPrecoAdicionado";
import { LucideIcon, CircleDot } from "lucide-react";
import { IItemHistoricoPlano, IItemHistoricoServico } from "../../types";

const REGISTRY: CardHistoricoConfig[] = [
  novoPrecoAdicionadoConfig, // Verificar primeiro para pegar TEMPLATE_GLOBAL
  servicoCriadoConfig,
  servicoEditadoConfig,
  planoCriadoConfig,
  servicoAdicionadoConfig,
  planoEditadoConfig,
  precificacaoEditadaConfig,
];

export function getCardForItem(item: IItemHistoricoPlano | IItemHistoricoServico): CardHistoricoConfig | null {
  const itemPlano = item as IItemHistoricoPlano;
  const origem_evento = itemPlano.origem_evento;
  
  for (const config of REGISTRY) {
    if (config.detectaTipo(item.acao, origem_evento)) {
      return config;
    }
  }
  
  return null;
}

export function getIconForAction(
  acao: string,
  origem_evento?: string
): { Icon: LucideIcon; color: string } {
  const config = REGISTRY.find((c) => c.detectaTipo(acao, origem_evento));
  if (config) {
    return config.getIcon(acao, origem_evento);
  }
  
  // Default icon
  return { Icon: CircleDot, color: "var(--c6b7280)" };
}
